import IconSvg from './assets/icons/32/lockInfo.svg';
import { FC } from 'react';

const Icon: FC = (props) => <img alt="Lock info" src={IconSvg} width="48px" height="48px" {...props} />;

export default Icon;
